export var DEFAULT_NAMESPACE='/';export var ACTION_TYPE_DELIMITER='||';